(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["daw-wohny-webapp"] = factory();
	else
		root["daw-wohny-webapp"] = factory();
})(globalThis, () => {
return 